var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.list},scopedSlots:_vm._u([{key:"money",fn:function(ref){
var row = ref.row;
return [_c('Tag',{attrs:{"type":"border","color":row.money > 0 ? 'success' : 'error'}},[_vm._v(_vm._s(_vm._f("money")(row.money)))])]}},{key:"current",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm._f("money")(row.current))+" ")]}},{key:"created_at",fn:function(ref){
var row = ref.row;
return [_c('Time',{attrs:{"time":row.created_at * 1000,"type":"datetime"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }